import { FC } from 'react'
import {
  ActiveMarkerType,
  HandleActiveMarker,
  Location,
  OnMarkerClickType,
} from '@components/Location/location.types'
import { InfoWindow, Marker } from '@react-google-maps/api'
import Link from 'next/link'
import { useRouter } from 'next/router'

const MarkerWithInfo: FC<{
  location: Location
  onMarkerClick?: OnMarkerClickType
  activeMarker: ActiveMarkerType
  handleActiveMarker: HandleActiveMarker
}> = ({ location, onMarkerClick, activeMarker, handleActiveMarker }) => {
  const { id, slug, nickName, address, city, state, zip, lat, lng } = location
  const router = useRouter()

  return (
    <Marker
      key={`marker-${id}`}
      position={{
        lat: Number(lat),
        lng: Number(lng),
      }}
      onClick={() => {
        onMarkerClick ? onMarkerClick(id) : handleActiveMarker(id)
      }}
    >
      {activeMarker === id ? (
        <InfoWindow
          onCloseClick={() => handleActiveMarker(null)}
          key={`info-window-${id}`}
        >
          <div className="flex flex-col gap-2 text-11">
            <div className="font-bold font-raleway">
              {nickName.toUpperCase()}
            </div>
            <div>
              <div>{address}</div>
              <div>
                {city}, {state} {zip}
              </div>
            </div>
            {router.pathname === '/location' ? (
              <div className="flex-col">
                <div className="pt-2">
                  <Link
                    href={`/location/${state}/${city}/${slug}`}
                    className={
                      'text-bidfta-blue-light font-bold hover:underline text-11 md:text-xs'
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    LOCATION DETAILS
                  </Link>
                </div>
                <div className="pt-2">
                  <Link
                    href={`/category/all/1?location=${id}`}
                    className={
                      'text-bidfta-blue-light font-bold hover:underline text-11 md:text-xs'
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    SEE AUCTIONS
                  </Link>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </InfoWindow>
      ) : null}
    </Marker>
  )
}

export default MarkerWithInfo
